import { createIcon } from '../utils';

export const ClosedEnvelopePatientTimelineIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x={0.650024}
        y={0.649902}
        width={23}
        height={19}
        rx={3}
        className={innerClassName}
        fillOpacity={0.16}
      />
      <path
        d="M23.075 17.2749L15.4357 10.1499M8.86431 10.1499L1.22506 17.2749M0.650024 4.2124L10.0397 10.9995C10.8 11.5491 11.1802 11.8239 11.5937 11.9303C11.959 12.0244 12.341 12.0244 12.7063 11.9303C13.1198 11.8239 13.5 11.5491 14.2604 10.9995L23.65 4.2124M6.17002 19.6499H18.13C20.0622 19.6499 21.0283 19.6499 21.7663 19.2616C22.4155 18.9201 22.9432 18.3751 23.274 17.7047C23.65 16.9427 23.65 15.9451 23.65 13.9499V6.3499C23.65 4.35472 23.65 3.35712 23.274 2.59506C22.9432 1.92473 22.4155 1.37974 21.7663 1.03819C21.0283 0.649902 20.0622 0.649902 18.13 0.649902H6.17002C4.23784 0.649902 3.27175 0.649902 2.53376 1.03819C1.8846 1.37974 1.35682 1.92473 1.02605 2.59506C0.650024 3.35712 0.650024 4.35472 0.650024 6.3499V13.9499C0.650024 15.9451 0.650024 16.9427 1.02605 17.7047C1.35682 18.3751 1.8846 18.9201 2.53376 19.2616C3.27175 19.6499 4.23784 19.6499 6.17002 19.6499Z"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'ClosedEnvelopePatientTimelineIcon' },
);
